import React from "react";
import ToggleControl from "../toggleControl/toggleControl";
import type { CheckboxModel } from "../../type/toggleControl";
import "./checkbox.scss";

const Checkbox: React.FC<CheckboxModel> = ({
  label,
  description,
  checked,
  onChange,
  saving = false,
  variant = "default",
  className = ""
}) => {
  const variantClass = variant === "compact" ? "setting-toggle-item-compact" : "setting-toggle-item-default";
  
  return (
    <div className={`setting-toggle-item ${variantClass} ${className}`.trim()}>
      <div className="setting-toggle-item-info">
        <div className="setting-toggle-item-label">{label}</div>
        <div className="setting-toggle-item-description">{description}</div>
      </div>

      <ToggleControl
        checked={checked}
        onChange={onChange}
        label={label}
        saving={saving}
      />
    </div>
  );
};

export default Checkbox;